import React from 'react'

const GroundingChord = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">ESD Lab Setup</a>
                        <i class="fa fa-angle-right"></i>
                        <span>Grounding Cord</span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/grounding.png' width={400}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>Grounding Cord:</h2>
                        <p className="mbot25">
                            <b style={{ textDecoration: "underline", marginRight: '5px' }}>Description:</b>
                            A grounding cord is an essential tool in an ESD
                            lab, used to connect ESD-safe surfaces and equipment to a
                            common ground point. This ensures that any static charges
                            are safely dissipated, preventing buildup that could damage
                            sensitive electronic components. Grounding cords are
                            typically flexible and durable, making them suitable for
                            various applications within the lab.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GroundingChord
